import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { AdvancedDataSource } from 'src/app/controls/advanced-gridview/datasources/advanced-datasource';
import { AdvancedGridviewModel } from 'src/app/controls/advanced-gridview/models/advanced-gridview-model';
import { ColumnDefinition } from 'src/app/controls/advanced-gridview/models/column-definition';
import { ColumnListDefinition } from 'src/app/controls/advanced-gridview/models/column-list-definition';
import { ColumnType } from 'src/app/controls/advanced-gridview/models/column-type';
import { MenuITemAction } from 'src/app/controls/advanced-gridview/models/menu-item-action';
import { MenuItemEvent } from 'src/app/controls/advanced-gridview/models/menu-item-event';
import { SortInfos } from 'src/app/controls/advanced-gridview/models/sort-infos';
import { FilterType } from 'src/app/controls/filters/models/filter-type';
import { ListItem } from 'src/app/controls/filters/models/list-item';
import { DefaultListComponent } from 'src/app/controls/list/default-list/default-list.component';
import { EnumHelper } from 'src/app/helpers/enum-helper';
import { Rights } from 'src/app/models/enums/rights';
import { ProcessDefinition } from 'src/app/models/process-definition';
import { CustomersService } from 'src/app/services/customers.service';
import { DocumentTypesService } from 'src/app/services/document-type.service';
import { MemoryService } from 'src/app/services/memory.service';
import { NotificationService } from 'src/app/services/notification-service';
import { ProcessDefinitionService } from 'src/app/services/process-definition.service';
import { AdvancedGridviewComponent } from '../../../controls/advanced-gridview/advanced-gridview.component';

@Component({
    selector: 'app-process-definitions-list',
    templateUrl: './process-definitions-list.component.html',
    styleUrls: ['./process-definitions-list.component.scss'],
    imports: [AdvancedGridviewComponent]
})
export class ProcessDefinitionsListComponent extends DefaultListComponent<ProcessDefinition> implements OnInit {
    /**
     * Configuration des colonnes de la liste.
     */
    tableConfig: ColumnDefinition[] = null;

    /**
     * Constructeur
     * @param dialog : Service pour ouvrir des boites de dialogue.
     * @param memoryService : Service pour récupérer les informations en mémoire.
     * @param enumHelper : Classe utilitaire pour les énumérations.
     * @param processDefinitionService : Service de gestion des processus.
     * @param boxeservice : Service de gestion des bannettes.
     */
    constructor(
        public override dialog: MatDialog,
        protected override memoryService: MemoryService,
        public enumHelper: EnumHelper,
        private processDefinitionService: ProcessDefinitionService,
        private customersService: CustomersService,
        private documentTypesService: DocumentTypesService,
        private spinner: NgxSpinnerService,
        private notificationService: NotificationService
    ) {
        super(dialog, memoryService);

        if (this.memoryService.getConnectedUser().params.idVisible === true) {
            this.tableConfig = [
                new ColumnDefinition('id', 'Id', ColumnType.Numeric, FilterType.Text, 1, 5, true),
                new ColumnDefinition('name', 'Nom', ColumnType.Text, FilterType.Text, 2, 25, true),
                new ColumnListDefinition('type', 'Type de processus', FilterType.List, 3, 10, true, false),
                new ColumnListDefinition('customerId', 'Client', FilterType.List, 4, 20, true, false),
                new ColumnListDefinition('documentTypeId', 'Type de document', FilterType.List, 5, 20, true, false),
                new ColumnDefinition('issuer', 'Emetteur', ColumnType.Text, FilterType.Text, 6, 15, true),
            ];
        } else {
            this.tableConfig = [
                new ColumnDefinition('name', 'Nom', ColumnType.Text, FilterType.Text, 2, 25, true),
                new ColumnListDefinition('type', 'Type de processus', FilterType.List, 3, 10, true, false),
                new ColumnListDefinition('customerId', 'Client', FilterType.List, 4, 20, true, false),
                new ColumnListDefinition('documentTypeId', 'Type de document', FilterType.List, 5, 20, true, false),
                new ColumnDefinition('issuer', 'Emetteur', ColumnType.Text, FilterType.Text, 6, 20, true),
            ];
        }

        this.AddMenuItem('Dupliquer', MenuITemAction.Duplicate, Rights.ProcessCreate);
        this.AddMenuItem('Éditer', MenuITemAction.Update, Rights.ProcessEdit);
        this.AddMenuItem('Supprimer', MenuITemAction.Delete, Rights.ProcessDelete);
    }

    /**
     * Initialise le composant.
     */
    ngOnInit(): void {
        this.dataSource = new AdvancedDataSource(null, this.processDefinitionService, this.spinner, this.notificationService);
        this.filteredTableModel = new AdvancedGridviewModel(this.tableConfig, new SortInfos('name', 'asc'));

        // Ajout des listes déroulantes
        // attente de 500ms pour que la gridView ait le temps de se remplir.
        setTimeout(() => {
            this.loadListColumnFilterDatas();
        }, 500);
    }

    /**
     * Appellé lorsque l'utilisateur clique sur un élément du menu contextuel.
     * @param event : Événement retourné par le menu contextuel.
     */
    public onAction(event: MenuItemEvent<ProcessDefinition>): void {
        if (event.action == MenuITemAction.Read) {
            // Cas de la consultation.
            this.itemDisplayed.emit(event.context);
        } else if (event.action == MenuITemAction.Update) {
            // Cas de la mise à jour.
            this.itemEdited.emit(event.context);
        } else if (event.action == MenuITemAction.Duplicate) {
            // Cas de duplication.
            this.itemDuplicated.emit(event.context);
        } else if (event.action == MenuITemAction.Delete) {
            // Cas de la suppression --> affichage de la boite de dialogue de confirmation.
            this.displayDeleteConfirmationDialog(`Vous êtes sur le point de supprimer la définition de processus '${event.context.name}'.`, event.context);
        }
    }

    /**
     * Charge les éléments des filtres des colonnes de type liste.
     */
    private loadListColumnFilterDatas(): void {
        this.customersService.List(null, null, null, null).subscribe((x) => {
            var listItem = x.value.map<ListItem<string>>((v) => <ListItem<string>>{ value: v.id.toString(), text: v.name });
            this.loadColumn(
                this.filteredTableModel.displayedColumnsDefinitions.find(
                    (x) => this.enumHelper.areEquals(ColumnType, x.type, ColumnType.List) && x.columnName === 'customerId'
                ) as ColumnListDefinition<string>,
                listItem
            );
        });

        this.documentTypesService.List(null, null, null, null).subscribe((x) => {
            var listItem = x.value.map<ListItem<string>>((v) => <ListItem<string>>{ value: v.id.toString(), text: v.name });
            this.loadColumn(
                this.filteredTableModel.displayedColumnsDefinitions.find(
                    (x) => this.enumHelper.areEquals(ColumnType, x.type, ColumnType.List) && x.columnName === 'documentTypeId'
                ) as ColumnListDefinition<string>,
                listItem
            );
        });

        var listItem = [
            new ListItem<string>('0', 'Identification du client'),
            new ListItem<string>('1', 'Identification du type de document'),
            new ListItem<string>('2', "Assignation d'attributs"),
            new ListItem<string>('3', 'Rattachement automatique'),
        ];

        this.loadColumn(
            this.filteredTableModel.displayedColumnsDefinitions.find(
                (x) => this.enumHelper.areEquals(ColumnType, x.type, ColumnType.List) && x.columnName === 'type'
            ) as ColumnListDefinition<string>,
            listItem
        );
    }
}
